// extracted by mini-css-extract-plugin
export default {"home":"index_home__Ag2BY","content":"index_content__gnDKt","top":"index_top__xHsrm","table":"index_table__XHWbW"};